import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import TableBody from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableBody';
import CollapsableTableRow
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/Allocations/TableView/CollapsableTable/CollapsableTableRow';
import TableRowSetLabel
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/Allocations/TableView/CollapsableTable/TableRowSetLabel';

const styles = () => ({
  root: {},
});

const CollapsableTableBody = ({
  className,
  classes,
  data,
  isRowSet,
  onCellFormSubmitOverride,
  onLockRow,
}) => {
  return (
    <TableBody className={classNames(classes.root, className)}>
      {data.map(row => {
        return (
          <React.Fragment key={row.id}>
            {row.rowSetLabel && (
              <TableRowSetLabel
                label={row.rowSetLabel}
              />
            )}
            <CollapsableTableRow
              label={row.label}
              altLabel={row.altLabel}
              subLabel={row.subLabel}
              rowResource={row.rowResource}
              rowDetailsUrl={row.rowDetailsUrl}
              data={row.data}
              rowSetLabel={row.rowSetLabel}
              rowSets={row.rowSets}
              rowSummarySet={row.rowSummarySet}
              isRowSet={isRowSet}
              cellType={row.cellType}
              onCellFormSubmitOverride={onCellFormSubmitOverride}
              onLockRow={onLockRow}
            />
          </React.Fragment>);
      })}
    </TableBody>

  );
};

CollapsableTableBody.defaultProps = {
  className: '',
  isRowSet: false,
  onCellFormSubmitOverride: null,
  onLockRow: null,
};

CollapsableTableBody.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  isRowSet: PropTypes.bool,
  onCellFormSubmitOverride: PropTypes.func,
  onLockRow: PropTypes.func,
};

export default withStyles(styles)(CollapsableTableBody);
